import {
  openWindowScopeConfig,
  createAppSessionID,
  getUserId,
  getSessionId,
  eventDataTransformer,
  timeDiffMinutes,
  getSessionTimeOutTime,
  checKBlackListEventType,
} from 'utils/index';

import { getSDKConfig, setSDKConfig } from 'utils/config';
import {
  initQueueManager,
  storeNextData,
  executeLastSessionStoreData,
  executeCurrentBatchData,
} from 'src/queueManager';
import { log } from 'src/consoleManager';
import { GODAVARI_EVENT_TYPE, SESSION_DATA_EVENTS_LIST } from 'src/utils/enum';
import { isGVAllowed } from './utils';
import { addEventCount } from '../utils/eventsCounter';
import { updateSessionId } from '../utils';

const AnalyticsConnector = () => {
  log('AnalyticsConnector initialized');
  const userId = getUserId();
  let sessionId = getSessionId();
  let pageStartTime = Date.now();
  const sessionStartTime = Date.now();
  let currentPageId = '';
  let pageDuration = 0;
  let startTime;

  document.addEventListener(
    'visibilitychange',
    checkTimeDiffToGenerateNewId,
    false
  );

  function checkTimeDiffToGenerateNewId() {
    const sessionTimeOut = getSessionTimeOutTime();
    if (document.visibilityState === 'hidden') {
      startTime = new Date();
    } else if (startTime) {
      let endTime = new Date();
      const calculateTimeDiff = timeDiffMinutes(endTime, startTime);
      if (parseFloat(calculateTimeDiff) >= parseFloat(sessionTimeOut)) {
        executeCurrentBatchData();
        sessionId = getSessionId();
      }
    }
  }

  const captureEvent = (eventObj) => {
    const isGVAllow = isGVAllowed();

    if (!isGVAllow) return;
    if (!eventObj) return;

    const eventType = getEventType(eventObj);

    addEventCount(eventObj.event_name);
    const blackListEvent = checKBlackListEventType(eventObj);
    if (blackListEvent) {
      return;
    }

    eventObj = addEventAttributes(eventObj);

    let overrideEnum = localStorage.getItem('GODAVARI_ENUM_OVERRIDE');

    if (overrideEnum === 'true') {
      eventObj = eventDataTransformer(eventObj);
    }

    if (eventType) {
      storeNextData(eventType, eventObj.event_name, eventObj);
    }
  };

  const getEventType = (eventObj) => {
    const sdkConfig = getSDKConfig();
    if (sdkConfig) {
      const isPriorityEvent = sdkConfig?.priority_events?.some(
        (eventName) => eventName === eventObj.event_name
      );

      if (isPriorityEvent) return GODAVARI_EVENT_TYPE.PRIORITY;

      return GODAVARI_EVENT_TYPE.BATCHED;
    }
  };

  const addEventAttributes = (eventObj) => {
    if (eventObj.event_data?.PageID !== currentPageId) {
      currentPageId = eventObj.event_data?.PageID;
      pageDuration = Date.now() - pageStartTime;
      pageStartTime = Date.now();
    }

    // Event context attributes
    const session_id = sessionId || getSessionId();
    updateSessionId(session_id);
    const user_id = userId || getUserId();
    const event_id = `${session_id}-${Date.now()}-${Math.floor(10000 + Math.random() * 90000)}`;

    const sdkVersion =
      (window.spnGodavariGv2AnalyticsInfo &&
        window.spnGodavariGv2AnalyticsInfo.analyticsSDKVersion) ||
      'latest';

    eventObj.context.SessionId = session_id;
    eventObj.context.GvClientId = user_id;
    eventObj.context.SdkVersion = sdkVersion;

    // Event data attributes
    if (SESSION_DATA_EVENTS_LIST.indexOf(eventObj.event_name) !== -1) {
      const sessionDuration = Date.now() - sessionStartTime;
      eventObj.event_data.SessionDuration = sessionDuration;
      eventObj.event_data.PreviousScreenTime =
        eventObj.event_data.PreviousScreen &&
        eventObj.event_data.PreviousScreen !== 'NA'
          ? pageDuration
          : 'NA';
    }

    eventObj.event_id = event_id;

    return eventObj;
  };

  return {
    captureEvent,
    setSDKConfig,
  };
};

openWindowScopeConfig();
createAppSessionID();
initQueueManager();
executeLastSessionStoreData();

export default AnalyticsConnector;
